import { useState } from "react";
import * as api from "../lib/api";

/**
 * The passphrase gate.
 *
 * Only reached when the deployment sets APP_PASSPHRASE. The session cookie
 * lasts 90 days, so on a phone this should be a once-a-quarter interruption
 * rather than a daily one.
 */
export default function Login({ onUnlocked }: { onUnlocked: () => void }) {
  const [passphrase, setPassphrase] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function submit() {
    if (!passphrase.trim() || busy) return;
    setBusy(true);
    setError(null);
    try {
      await api.login(passphrase);
      setPassphrase("");
      onUnlocked();
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="empty" style={{ paddingTop: 60 }}>
      <div className="big">🔒</div>
      <h1 style={{ marginBottom: 6 }}>Vocabulaire</h1>
      <p className="lede">Enter the passphrase to continue.</p>

      <div className="stack" style={{ maxWidth: 320, margin: "0 auto", textAlign: "left" }}>
        <input
          type="password"
          autoComplete="current-password"
          aria-label="Passphrase"
          value={passphrase}
          disabled={busy}
          onChange={(e) => setPassphrase(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") void submit();
          }}
        />
        <button className="btn primary full" disabled={busy || !passphrase.trim()} onClick={() => void submit()}>
          {busy ? <><span className="spinner" /> Checking…</> : "Unlock"}
        </button>
        {error && <div className="notice error">{error}</div>}
      </div>
    </div>
  );
}
